import type React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";

interface PassedProps {
  explanation?: string | JSX.Element;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const Email = ({
  value,
  isErrored,
  onChange,
  explanation = "",
  intl,
  onKeyDown = () => {},
  onBlur = () => {},
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const isFieldHidden = getFieldConfigByFieldId("email")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="email"
      value={value}
      onChange={onChange}
      type="email"
      autoComplete="email"
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({ id: "emailAddressPlaceholder", defaultMessage: "Email" })
      }
      label={<FormattedHTMLMessage id="emailAddress" defaultMessage="Email address" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidEmail" defaultMessage="Invalid email" />
        )
      }
      explanation={explanation}
      showPlaceholderAndHideLabel={!!placeholder}
      onKeyDown={(e) => onKeyDown(e)}
      onBlur={(e) => onBlur(e)}
      disabled={disabled}
    />
  );
};

export const EmailComponent = injectIntl(Email);
